import { Sorting } from '@models';
import { searchService } from '@services';
import { BaseComponent } from '../base.component';
import defaultHtml from './sorting.component.hbs';

export class SortingComponent extends BaseComponent<Sorting> {
    protected override bindEvent = 'hawksearch:bind-sorting';
    protected override customTemplatePropertyName = 'sorting';
    protected override defaultHtml = defaultHtml;

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data?.options?.length) {
            return '';
        }

        const html = template(this.data);

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll('[hawksearch-sort]').forEach((e) => {
            e.addEventListener('change', (event: Event) => {
                event.preventDefault();

                const element = event.currentTarget as HTMLSelectElement;
                const value = element.value;

                searchService.sort(value);
            });
        });
    }
}
